import { combineReducers } from 'redux';
import app from './app/index.tsx';
import copyFilterModal from './copy-filter-modal/index.tsx';
import filters from './filters/index.tsx';
import query from './query/index.tsx';

export default combineReducers({
	app,
	filters,
	query,
	copyFilterModal,
});
